import React from "react";
import { Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import qgisIcon from "../../Assets/qgis.png";
import arcgisIcon from "../../Assets/arcgis.png";
import rstudioIcon from "../../Assets/rstudio.png";
import pythonIcon from "../../Assets/python.png";
import psqlIcon from "../../Assets/postgressql.png";
import geeIcon from "../../Assets/GEE.png";

const icons = [
  { src: qgisIcon, alt: "QGIS", label: "Qgis" },
  { src: arcgisIcon, alt: "ArcGIS", label: "ArcGIS" },
  { src: rstudioIcon, alt: "RStudio", label: "RStudio" },
  { src: pythonIcon, alt: "Python", label: "Python" },
  { src: psqlIcon, alt: "PostgreSQL", label: "PostgreSQL" },
  { src: geeIcon, alt: "Google Earth Engine", label: "Google Earth Engine" },
];

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {icons.map(({ src, alt, label }, idx) => (
        <Col xs={4} md={2} className="tech-icons" key={idx}>
          <OverlayTrigger
            placement="top"
            trigger="click"
            overlay={
              <Tooltip id={`tooltip-${label}`}>
                {label}
              </Tooltip>
            }
            rootClose
          >
            <img
              src={src}
              alt={alt}
              width="100"
              height="100"
              style={{ cursor: "pointer" }}
            />
          </OverlayTrigger>
        </Col>
      ))}
    </Row>
  );
}

export default Techstack;
